const state = {
    list: {}, // 试卷列表页头详情
}

const actions = {
    updateReviewTeacherList({ commit }, data) {
        commit("setReviewTeacherList", data);
    }
}

const mutations = {
    setReviewTeacherList(state, payload) {
        state.list = payload
    }
}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}